import { AccessLevel } from '@/modules/common/enums/access-levels.enum'
import GtrSuper from '@/modules/common/components/mixins/gtr-super.mixin'
import ErrorHandlerService from '@/modules/common/services/error-handler.service'
import Container from 'typedi'
import { Component } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'GtrAdminLayout',
  computed: {
    ...mapState('common', ['noticeDisplayed']),
    ...mapState('security', ['currentUser'])
  }
})
export default class GtrAdminLayout extends GtrSuper {
  AccessLevel = AccessLevel

  async mounted () {
    try {
      await this.$store.dispatch('security/getCurrentUser')
    } catch (error) {
      Container.get(ErrorHandlerService).error(error)
    }
  }
}
